import React from "react";
import { Link } from "react-router-dom";
import ArticleThumbnail from "../../../assets/images/ArticleThumbnail.svg";
import {
  constants,
  DateFormat,
} from "../../../Containers/Constants/commenFeatures";

const Article = ({ article, key }) => {
  return (
    <div key={key} className="display-flex align-center articleWraps">
      <div className="grey_box">
        <img src={ArticleThumbnail} alt={ArticleThumbnail} />
      </div>
      <div className="right_content">
        <div className="infos">
          <Link to={article ? `/articles/${article.resourceId}` : ""}>
            <h6>{article ? article.name : ""}</h6>
          </Link>
        </div>
        <div className="display-flex align-center articleWrapsInfo">
          <p className="date">
            {article
              ? DateFormat(article.date, constants.resourceDateFormat)
              : ""}
          </p>
          {/* <p>
            <a
              className="disabled"
              href={
                article.productLink ? article.productLink : "javascript:void(0)"
              }
            >
              Product
            </a>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Article;
